/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Sync_Sync_Changes_ButtonInputs */

const en_team_sync_sync_changes_button = /** @type {(inputs: Team_Sync_Sync_Changes_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sync Changes`)
};

const fr_team_sync_sync_changes_button = /** @type {(inputs: Team_Sync_Sync_Changes_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Synchroniser les modifications`)
};

const de_team_sync_sync_changes_button = /** @type {(inputs: Team_Sync_Sync_Changes_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Änderungen synchronisieren`)
};

const it_team_sync_sync_changes_button = /** @type {(inputs: Team_Sync_Sync_Changes_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sincronizza modifiche`)
};

const ru_team_sync_sync_changes_button = /** @type {(inputs: Team_Sync_Sync_Changes_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Изменения синхронизации`)
};

const es_team_sync_sync_changes_button = /** @type {(inputs: Team_Sync_Sync_Changes_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sincronizar cambios`)
};

const zh_cn2_team_sync_sync_changes_button = /** @type {(inputs: Team_Sync_Sync_Changes_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`同步更改`)
};

const ja_team_sync_sync_changes_button = /** @type {(inputs: Team_Sync_Sync_Changes_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`変更を同期`)
};

const hi_team_sync_sync_changes_button = /** @type {(inputs: Team_Sync_Sync_Changes_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`परिवर्तनों को सिंक्रनाइज़ करें`)
};

const pt_pt2_team_sync_sync_changes_button = /** @type {(inputs: Team_Sync_Sync_Changes_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sincronizar alterações`)
};

/**
* | output |
* | --- |
* | "Sync Changes" |
*
* @param {Team_Sync_Sync_Changes_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_sync_sync_changes_button = /** @type {((inputs?: Team_Sync_Sync_Changes_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Sync_Sync_Changes_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_team_sync_sync_changes_button(inputs)
	if (locale === "de") return de_team_sync_sync_changes_button(inputs)
	if (locale === "it") return it_team_sync_sync_changes_button(inputs)
	if (locale === "ru") return ru_team_sync_sync_changes_button(inputs)
	if (locale === "es") return es_team_sync_sync_changes_button(inputs)
	if (locale === "zh-CN") return zh_cn2_team_sync_sync_changes_button(inputs)
	if (locale === "ja") return ja_team_sync_sync_changes_button(inputs)
	if (locale === "hi") return hi_team_sync_sync_changes_button(inputs)
	if (locale === "pt-PT") return pt_pt2_team_sync_sync_changes_button(inputs)
	return en_team_sync_sync_changes_button(inputs)
});